import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Stream an SSE endpoint via fetch. onDelta(text), onDone(html), onError(msg)
export async function streamPost(path, body, { onDelta, onDone, onError }) {
  try {
    const res = await fetch(`${API}${path}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      onError?.(formatApiErrorDetail(data.detail) || `Errore ${res.status}`);
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const payload = line.slice(5).trim();
        if (!payload) continue;
        try {
          const evt = JSON.parse(payload);
          if (evt.error) onError?.(evt.error);
          else if (evt.done) onDone?.(evt.html);
          else if (evt.delta) onDelta?.(evt.delta);
        } catch (_) {
          // ignore incomplete/partial SSE frame; the next read completes it
        }
      }
    }
  } catch (e) {
    onError?.(e.message || "Errore di connessione");
  }
}

// Stripe pages refuse to render inside iframes: escape the frame when embedded.
export function redirectExternal(url) {
  if (window.self === window.top) {
    window.location.href = url;
    return;
  }
  const win = window.open(url, "_blank");
  if (win) {
    win.opener = null;
    return;
  }
  try {
    window.top.location.href = url;
  } catch {
    window.location.href = url;
  }
}
